export default __webpack_public_path__ + "static/media/speakers.e870fc5a.jpg";